import { LocationDescriptor } from 'history';

import { getSafeReturnToOrNull } from 'src/urls/sanitizeReturnTo';

import useCurrentRoute from './useCurrentRoute';
import { PARAM_LOGIN_WITH_POPUP, useLoginWithPopup } from './useLoginWithPopup';
import { SearchParamKnownKeys } from './useUrlSearchParams';

export type LocationState = {
  redirectUrl: string;
};

const useLoginToParams = (): LocationDescriptor<LocationState> => {
  const currentRoute = useCurrentRoute();
  // Check to see if URL before re-route is requesting a login with popup
  const showLoginWithPopup = useLoginWithPopup();

  // Build search params
  const searchParams = new URLSearchParams();

  if (showLoginWithPopup) {
    searchParams.append(PARAM_LOGIN_WITH_POPUP, 'true');
  }

  // Add return_to parameter using the current route
  const returnTo = getSafeReturnToOrNull(currentRoute);
  if (returnTo) {
    searchParams.append(SearchParamKnownKeys.RETURN_TO, returnTo);
  }

  return {
    pathname: '/login',
    search: searchParams.toString() ? `?${searchParams.toString()}` : '',
    state: {
      redirectUrl: returnTo || '/',
    },
  };
};

export default useLoginToParams;
